import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m21.92 17 1.32-10a.75.75 0 0 0-1.08-.78l-4.28 3.34a.74.74 0 0 1-1.09-.16l-4.23-6.18a.74.74 0 0 0-1.12 0L7.21 9.4a.74.74 0 0 1-1.09.16L1.84 6.3a.75.75 0 0 0-1.08.78L2.08 17ZM2.25 21.03h19.5"
    }, null, -1)
  ]));
}
const interfaceAwardCrown = { render };
export {
  interfaceAwardCrown as default,
  render
};
//# sourceMappingURL=interface-award-crown.svg.js.map
